import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Analytics from './utils/analytics';
import Navbar from './components/Navbar';
import TopBar from './components/TopBar';
import Footer from './components/Footer';
import Home from './components/Home';
import Login from './components/Login';
import Signup from './components/Signup';
import JoinTeam from './components/JoinTeam';
import ArtisanProfile from './components/ArtisanProfile';
import ArtisanLayout from './components/artisan/ArtisanLayout';
import ArtisanDashboard from './components/artisan/ArtisanDashboard';
import IncomingRequests from './components/IncomingRequests';
import AdminBookingsList from './components/admin/AdminBookingsList';
import AdminLayout from './components/admin/AdminLayout';
import TeamList from './components/admin/TeamList';
import CustomerList from './components/admin/CustomerList';
import Dashboard from './components/admin/Dashboard';
import ErrorBoundary from './components/ErrorBoundary';
import BookingWizard from './components/BookingWizard';
import CustomerDashboard from './components/CustomerDashboard';
import { AuthProvider } from './context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css'; // Make sure global styles are applied

function App() {
  useEffect(() => {
    Analytics.init();
  }, []);

  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/artisan') || location.pathname.startsWith('/admin');

  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "440984348787-PLACEHOLDER.apps.googleusercontent.com"}>
        <AuthProvider>
          <div className={`App ${isDashboard ? 'dashboard-mode' : ''}`}>
            {!isDashboard && (
              <div className="header-wrapper">
                <TopBar />
                <Navbar />
              </div>
            )}

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/book" element={<BookingWizard />} />
              <Route path="/book/location" element={<BookingWizard startStep={2} />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/join" element={<JoinTeam />} />
              <Route path="/dashboard" element={<CustomerDashboard />} />

              {/* Artisan Routes */}
              <Route path="/artisan" element={<ArtisanLayout />}>
                <Route path="dashboard" element={<ArtisanDashboard />} />
                <Route path="profile" element={<ArtisanProfile />} />
                <Route path="requests" element={<IncomingRequests />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="team" element={<TeamList />} />
                <Route path="customers" element={<CustomerList />} />
                <Route path="bookings" element={<AdminBookingsList />} />
              </Route>
            </Routes>

            {!isDashboard && <Footer />}
          </div>
        </AuthProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;